import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Icon from '../../icon';
import classnames from 'classnames/bind';
import styles from './styles.scss';
import { ColorNames } from '../../../../constants/colorVars';
const cx = classnames.bind(styles);
const FilterButton = ({ icon, label, width, isFilterSelected, onOpen, isOpen, onReset, elmId, size = 'medium', }) => {
    const onClickRightButton = useCallback(() => {
        if (isFilterSelected) {
            onReset();
            onOpen(false);
        }
        else {
            onOpen(!isOpen);
        }
    }, [isFilterSelected, isOpen, onReset, onOpen]);
    const sizeClass = {
        small: size === 'small',
        medium: size === 'medium',
    };
    return (_jsx("button", { "data-elm-id": `${elmId}`, "aria-expanded": isOpen, "aria-haspopup": 'dialog', className: cx('filter-button', { active: isFilterSelected }, { 'fluid-width': width === 'fluid' }, sizeClass), children: _jsxs("div", { className: cx('container'), children: [_jsx("div", { className: cx('label', sizeClass, { 'full-radius': !!icon }), onClick: () => onOpen(!isOpen), children: _jsxs("div", { "data-elm-id": `${elmId}_left`, className: cx('label-text'), children: [icon && (_jsx(Icon, { color: ColorNames.Gray, iconStyle: 'solid', name: icon, size: 'medium', fitted: true })), label] }) }), !icon && (_jsx("div", { className: cx('right-button', sizeClass), onClick: onClickRightButton, "data-elm-id": `${elmId}_right`, children: isFilterSelected ? (_jsx(Icon, { color: ColorNames.Action, iconStyle: 'solid', name: 'xmark', size: 'medium', fitted: true })) : (_jsx(Icon, { color: ColorNames.Gray, iconStyle: 'solid', name: isOpen ? 'chevron-up' : 'chevron-down', size: 'medium', fitted: true })) }))] }) }));
};
export default FilterButton;
//# sourceMappingURL=index.js.map